import _ from 'lodash';
import { getCurrencyCode } from '@nexio/emvio-util-app';

import { generateMerchantIdsString } from '../MerchantSelector/merchantSelectorActions';

export const WIDGET_SETTINGS_UPDATE = 'WIDGET_SETTINGS/WIDGET_SETTINGS_UPDATE';

export function updateSettings(settings = {}) {
    const currencyId = settings.currencyId || '840';

    return {
        type: WIDGET_SETTINGS_UPDATE,
        payload: {
            currencyId: currencyId,
            currencyCode: _.toUpper(getCurrencyCode(currencyId))
        }
    };
}

export function filterMerchantsByCurrencyAsString(merchants, settings = {}) {
    const currencyId = _.get(settings, 'currencyId', '840');
    const filteredMerchants = _.filter(merchants, ['currencyId', currencyId]);

    return generateMerchantIdsString(filteredMerchants);
}
